// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"w_sz g_jk g_fl g_fp g_fz g_dH g_t","menuItemSub":"w_sB g_dP g_fl g_fz","menuMainLink":"w_sC g_jl g_hf","menuLink":"w_sD g_jl g_hf","Link":"w_rg p_rg p_qx p_qS"};